import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import { RetornaDataToNumero } from "../../../components/Formatters/DateTime";
import ReplaceChar from "../../../components/Formatters/ReplaceChar";

const useGerarOrdemServico = ({ formik }) => {
  const {
    request: gerarOrdemServicoRequest,
    data: gerarOrdemServicoData,
    errors: gerarOrdemServicoErrors,
    isLoading: gerarOrdemServicoIsLoading,
  } = useApiClient();

  const gerarOrdemServico = () => {
    const parametros = {
      sequencialTipoAcao: formik.values.sequencialTipoAcao,
      dataInicio: formik.values.dataInicio,
      dataFim: formik.values.dataFim,
      contribuintes: formik.values.contribuintes,
      textoPadrao: ReplaceChar(formik.values.textoPadrao),
      quantidadeDiasOs: formik.values.quantidadeDiasOs,
      procedimentos: formik.values.procedimentos,
      codigoDiretor: formik.values.codigoDiretor,
      listaExecutoresOs: formik.values.listaExecutoresOs,
      numeroAberturaProcesso: formik.values.numeroAberturaProcesso,
      sequencialDenuncia: formik.values.sequencialDenuncia,
      sequencialParteServico: formik.values.sequencialParteServico,
      textoPadraoOs: ReplaceChar(formik.values.textoPadraoOs),
    };
    if (RetornaDataToNumero(formik.values.dataInicio) > RetornaDataToNumero(formik.values.dataFim)) {
      toast.warning("Data inicial não pode ser maior que a data final");
      return;
    }
    gerarOrdemServicoRequest(apiRoutes.fiscalizacao.ordemservico.gerarOrdemServico, parametros);
  };

  useEffect(() => {
    if (gerarOrdemServicoIsLoading) return;

    if (!gerarOrdemServicoData) return;

    if (gerarOrdemServicoErrors) {
      toast.error(gerarOrdemServicoErrors.message);
    }
  }, [
    gerarOrdemServicoData,
    gerarOrdemServicoErrors,
    gerarOrdemServicoIsLoading,
    formik.values.dataInicio,
    formik.values.dataFim,
  ]);

  return { gerarOrdemServicoIsLoading, gerarOrdemServico, gerarOrdemServicoErrors, gerarOrdemServicoData };
};

export default useGerarOrdemServico;
